import React from 'react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
import { Waves } from './Waves';
import { Seed } from './Seed';
export function Close() {
  return <section className="w-full bg-white" data-id="element-46" data-mp="1uy2w0t2pqz0m">
      <Waves to="#FAF7F1" data-id="element-47" data-mp="1ux1imhy860fq" />
      <div className="relative overflow-hidden bg-paper" data-id="element-48" data-mp="1v0fo3z26qpre">
        <div aria-hidden="true" className="watercolor-light absolute inset-0" data-id="element-49" data-mp="1py6seuxxh9ll" />
        <div className="relative mx-auto max-w-3xl px-5 pb-16 pt-6 text-center sm:pb-20" data-id="element-50" data-mp="1l0otlxdmkarb">
          <Seed className="mx-auto h-16 w-16" data-id="element-51" data-mp="1g9ov4nouxkmp" />
          <h2 className="mt-5 font-display text-3xl font-semibold text-navy sm:text-5xl" data-id="element-52" data-mp="1g7vp9am2j4fr">
            Keep your evenings. <span className="wash-text" data-id="element-53" data-mp="1c83auh9zu42h">Open the week and run it.</span>
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-base text-navy-soft" data-id="element-54" data-mp="17abm1w4nay2i">
            Start safe, feel and regulate, know myself, connect, stress and loss,
            grow forward. Fifty-two sessions: written, processed and ready.
          </p>

          <div className="mt-7" data-id="element-55" data-mp="3vfoqeztznvas">
            <Countdown size="sm" data-id="element-56" data-mp="3vedl2vkwafhk" />
          </div>

          <div className="mx-auto mt-6 flex max-w-lg flex-wrap items-center justify-between gap-3 rounded-3xl bg-white px-5 py-4 text-left shadow-card" data-id="element-57" data-mp="3vdkfvz1l3y1j">
            <div data-id="element-58" data-mp="3lik0qq0xphp8">
              <span className="block text-xs font-bold text-teal-deep" data-id="element-59" data-mp="3lj27igl83ebe">Complete package</span>
              <span className="text-[15px] font-semibold text-navy" data-id="element-60" data-mp="3qgu0zf1in8hp">52 Weeks of Art-Based Sessions, 6 volumes + 5 bonuses</span>
            </div>
            <div className="flex items-baseline gap-2.5" data-id="element-61" data-mp="mzbp8wimhhc0">
              <span className="text-[15px] text-navy-muted line-through" data-id="element-62" data-mp="mytwi9v65l8u">$90</span>
              <span className="font-display text-4xl font-semibold leading-none text-navy" data-id="element-63" data-mp="81jfym3o5p69">$27</span>
            </div>
          </div>

          <div className="mx-auto mt-5 max-w-lg" data-id="element-64" data-mp="d38ptyf5nwsr">
            <CtaButton data-id="element-65" data-mp="2srigwbmaqxzd">Yes, I want all 52 sessions for $27</CtaButton>
          </div>

          <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-navy-muted" data-id="element-66" data-mp="2xrwra0bdek0k">
            {['Secure checkout', 'Instant access', '7-day guarantee'].map(item => <li key={item} className="flex items-center gap-2" data-id="element-67" data-mp="z9b6qaqxvwzg">
                <span className="h-1.5 w-1.5 rounded-full bg-teal" data-id="element-68" data-mp="zc749xyvkjnd" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}